import React from 'react';
import { TalkToJourneyMessage } from './types';

import monet from 'src/images/monet.png'
import { Nullable } from 'src/types/nullable.type';

export const TalkToJourneyBlockMessageIdentifier = ({
  name,
  message
}: {
  name?: Nullable<string>;
  message: TalkToJourneyMessage
}) => {
  if (message.role === 'assistant') {
    return (
      <div className="flex items-center space-x-2">
        <img className='w-6 h-6 rounded-full flex justify-center items-center shrink-0' src={monet} />
        <div className="text-neue-journey-medium-strong truncate text-neue-journey-fg-50">
          {name || 'Assistant'}
        </div>
      </div>
    )
  }

  return (
    <div className="flex items-center space-x-2">
      <div className='bg-neue-journey-fg-20 w-6 h-6 rounded-full flex justify-center items-center'>
        <div className='text-neue-journey-fg'>
          <svg width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M7.652 1.53882C8.33 2.17984 8.75 3.0662 8.75 4.04545C8.75 5.02471 8.33 5.91107 7.652 6.55209C6.97325 7.19382 6.03575 7.59091 5 7.59091C3.96425 7.59091 3.02675 7.19382 2.348 6.55209C1.67 5.91107 1.25 5.02471 1.25 4.04545C1.25 3.0662 1.67 2.17984 2.348 1.53882C3.02675 0.897091 3.96425 0.5 5 0.5C6.03575 0.5 6.97325 0.897091 7.652 1.53882ZM5 13.5C1.875 13.5 0 11.5303 0 10.7424C0 9.16665 1.875 8.77272 5 8.77272C8.03833 8.77272 10 9.16665 10 10.7424C10 11.5303 7.93167 13.5 5 13.5Z" fill="currentColor" fillOpacity="0.85" />
          </svg>
        </div>
      </div>
      <div className="text-neue-journey-medium-strong truncate text-neue-journey-fg-50">
        You
      </div>
    </div>    
  )
}